const list = {
  components() {
    return [
      {
        'component': 'search-select-company-tree',
        "label": '부서명',
        "value": 'companyTree',
        "query": {'c0': 'company0', 'c1': 'company1', 'c2': 'company2'},
        "options": {
          default: {company0: null, company1: null, company2: null},
        }
      },
      {'component': 'empty-space'},
      {
        'component': 'search-column-keyword',
        "label": '검색조건',
        "value": 'column',
        "query": {'ck_t': 'head', 'ck_k': 'keyword'},
        "options": {hiddenList: ['총 교육이수 시간', '입사일', '종료 예정일', '종료일', '행정전화']}
      },
      {
        'component': 'search-employee-type',
        "label": '계약상태',
        "value": 'employeeState',
        "query": {'eps': 'employeeState'},
        "options": { default: 'activated'}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // console.log("nav", search)

    //  검색조건
    const heads = list.getHead().map(e => {
      return {[e.name]: e.key}
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      if (search.column.head === '부서명') {
        conditions.push({
          boolean: 'AND',
          conditions: [
            {key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`},
            {boolean: 'OR', key: 'body.field_names[%]', operator: 'LIKE', value: `%${search.column.keyword}%`}
          ]
        })
      } else {
        conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
      }
    }

    // 계약 상태를 적용한다
    // now = 현재 날짜 (YYYY-MM-DD)
    const now = new Date().toISOString().split('T')[0];
    switch (search.employeeState) {
    case 'activated':
      conditions.push({key: 'body.retirement_date', operator: '>n', value: now})
      break;
    case 'retired':
      conditions.push({key: 'body.retirement_date', operator: '<=', value: now})
      break;
    default: break;
    }

    // console.log("conditions", conditions)
    return conditions;
  },
  getHead: () => {
    return [
      {name: "부서명", key: "body.fieldNames[%]"},
      {name: "ID(사번)", key: "body.employee_id"},
      {name: "팀명", key: "body.targetCompany"},
      {name: "업무분야", key: "body.job_category"},
      {name: "직종", key: "body.employment_type"},
      {name: "성별", key: "enc.gender"},
      {name: "성명", key: "enc.full_name"},
      {name: "입사일", key: "body.hire_date"},
      {name: "종료 예정일", key: "body.exp_retirement_date"},
      {name: "핸드폰", key: "enc.contact_number"},
      {name: "총 교육이수 시간", key: "body.inputC_2"},
      {name: "행정전화", key: "enc.contact_number_2"},
      {name: "종료일", key: "body.retirement_date"},
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: {
        // 사업장명
        const fieldNames = !func.getContent(value).fieldNames ? func.getContent(value).field_names : func.getContent(value).fieldNames;
        if (fieldNames && fieldNames.length === 1) {
          return fieldNames.join(", ");
        } else if (fieldNames && fieldNames.length > 1) {
          // 만약 두번째 아이템이 4글자 이하면 첫번째와 두번째 아이템을 쉼표로 붙여서 반환한다
          if (fieldNames[1].length <= 4) {
            return `${fieldNames[0]}, ${fieldNames[1]}`;
          } else {
            return `${fieldNames[0]}, ${fieldNames[1].substring(0, 4)}...`;
          }
        } else {
          return "-";
        }
      }
      case 1:
        return func.getContent(value).employee_id; // 사번
      case 2:
        return func.getContent(value).targetCompany; // 부서
      case 3:
        return func.getContent(value).job_category; // 업무분야
      case 4:
        return func.getContent(value).employment_type; // 직종
      case 5:
        return func.getContent(value).enc.gender; // 성별
      case 6:
        return func.getContent(value).enc.full_name; // 성명
      case 7:
        return func.getContent(value).hire_date; // 입사일
      case 8:
        return func.getContent(value).exp_retirement_date; // 종료 예정일
      case 9:
        return func.getContent(value).enc.contact_number; // 핸드폰
      case 10: {
        // 총 교육이수 시간
        if (typeof value.total_education_hours === "undefined") return "0시간 0분";
        const totalEducationHours = value.total_education_hours;

        // "H시간 M분" 형식으로 변환한다.
        // 데이터는 3.5 와 같은 형식으로 저장되어 있으며 "3시간 30분" 으로 변환되야 한다.
        const hours = Math.floor(totalEducationHours);
        const minutes = Math.round((totalEducationHours - hours) * 60);
        return `${hours}시간 ${minutes}분`;
      }
      case 11:
        return func.getContent(value).enc.contact_number_2; // 행정전화
      case 12:
        return func.getContent(value).retirement_date; // 종료일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    function getKey(searchType) {
      switch (searchType) {
      case "사업장명":
        return 'body.stdInfo.field_name';
      case "ID(사번)":
        return 'body.employee_id';
      case "부서":
        return 'body.targetCompany';
      case "업무분야":
        return 'body.job_category';
      case "직종":
        return 'body.employment_type';
      case "성별":
        return 'body.gender';
      case "성명":
        return 'body.full_name';
      case "입사일":
        return 'body.hire_date';
      case "종료 예정일":
        return 'body.exp_retirement_date';
      case "핸드폰":
        return 'body.contact_number';
      case "총 교육이수 시간":
        return 'body.inputC_2';
      case "행정전화":
        return 'body.contact_number_2';
      case "종료일":
        return 'body.retirement_date';
      }
    }

    nav.conditions = []
    nav.conditions.push({
      operator: "IN",
      value: nav.value.fieldName,
      key: "body.fieldNames[%]",
    })
    nav.conditions.push({
      operator: "LIKE",
      value: nav.value.searchKeyword,
      key: getKey(nav.value.searchType),
    })
    // nav.conditions.push({
    //   operator: "=",
    //   value: nav.value.company0,
    //   key: "body.department_name",
    // })

    return {conditions: nav.conditions};
    // if (nav.value.created_at) {
    //   nav.dateTarget = "created_at";
    //   nav.dateBegin = "nav.value.created_at.sDate";
    //   nav.dateEnd = "nav.value.created_at.eDate";
    // }
    // return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword, fieldId: nav.value.fieldId };
  },
  getSearchKeyword: (nav) => {
    const returnData = [];

    if (nav.value.fieldId) {
      returnData.push(`content$body.fields*%[:field_id]%`);
    }

    switch (nav.value.searchType) {
    case "사업장명":
      returnData.push("content$body.stdInfo.field_name*%[:default_skw]%");
      break;
    case "ID(사번)":
      returnData.push("content$body.employee_id*%[:default_skw]%");
      break;
    case "부서":
      returnData.push("content$body.targetCompany*%[:default_skw]%");
      break;
    case "업무분야":
      returnData.push("content$body.job_category*%[:default_skw]%");
      break;
    case "직종":
      returnData.push("content$body.employment_type*%[:default_skw]%");
      break;
    case "직급":
      returnData.push("content$body.job_title*%[:default_skw]%");
      break;
    case "성명":
      returnData.push("content$body.full_name*%[:default_skw]%");
      break;
    case "입사일":
      returnData.push("content$body.hire_date*%[:default_skw]%");
      break;
    case "종료 예정일":
      returnData.push("content$body.exp_retirement_date*%[:default_skw]%");
      break;
    case "핸드폰":
      returnData.push("content$body.contact_number*%[:default_skw]%");
      break;
    case "총 교육이수 시간":
      returnData.push("content$body.inputC_2*%[:default_skw]%");
      break;
    case "행정전화":
      returnData.push("content$body.contact_number_2*%[:default_skw]%");
      break;
    case "종료일":
      returnData.push("content$body.retirement_date*%[:default_skw]%");
      break;
    }
    return returnData;
  },

  excelInfo: (list) => {

    return {
      filePath: '/employees/종사자_업로드_템플릿.xlsx',
      downloadFileName: '종사자 정보(현황)',
      worksheetName: (data) => {
        return '종사자 정보(현황)';
      },
      singleSheet: (worksheet, list) => {
        for (let i = 0; i < list.length; i++) {
          const item = list[i];
          const body = JSON.parse(item.post_content).body;
          let fieldNames = [];
          if (body.fieldNames) {
            fieldNames = [...body.fieldNames]
          } else if (body.field_names) {
            fieldNames = [...body.field_names]
          }
          worksheet.addRow([
            i + 1, //no
            fieldNames.join(", "), // 부서명
            body.employee_id, //id
            body.targetCompany, //팀명
            body.enc.date_of_birth, //생년월일
            body.job_category, //업무분야
            body.employment_type, //직종
            body.enc.gender, //성별
            body.enc.full_name, //성명
            body.hire_date, //입사일
            body.exp_retirement_date, //종료예정일
            body.enc.contact_number, //핸드폰
            body.enc.contact_number_2, //행정전화
            body.retirement_date //종료일
          ])
        }
      },
    }
  }
};
export default list;
